import type { SegmentTrackPageElementClickedEvent } from "@beautypie/segment/Track/PageElementClicked";
import { trackClick } from "tracking";

export function carouselTracking() {
  const { pathname } = window.location;
  const isBasket = ["/basket", "/us/basket"].some((p) =>
    pathname.startsWith(p)
  );

  return {
    previousChevronClicked: () => {
      const event: SegmentTrackPageElementClickedEvent = {
        event: "Page Element Clicked",
        properties: {
          module_content: "promo_carousel",
          module_content2: "left",
          location_type: isBasket ? "basket_promo" : "pdp_promo"
        }
      };
      trackClick(event);
    },
    nextChevronClicked: () => {
      const event: SegmentTrackPageElementClickedEvent = {
        event: "Page Element Clicked",
        properties: {
          module_content: "promo_carousel",
          module_content2: "right",
          location_type: isBasket ? "basket_promo" : "pdp_promo"
        }
      };
      trackClick(event);
    }
  };
}
